import {useCallback} from 'react';

import {PaginationDataType} from '../../../util/pagination-hook/pagination-hook-type';
import {useApiHooks} from '../../api-hook/api-hook';

import {fetchReviewCompanies, fetchReviewCompanyGroups} from './review-companies-api';
import {
    CompanyResponseType,
    ReviewAnalysisCompaniesHookType,
    ReviewAnalysisCompanyGroupsHookType,
    ReviewsAnalysisCompaniesQueryType,
    ReviewsAnalysisCompanyGroupType,
    ReviewsAnalysisCompanyType,
} from './review-companies-type';

export function useReviewCompanies(): ReviewAnalysisCompaniesHookType {
    const {isInProgress, setIsInProgress, processError, setProcessError, result, setResult, reset} =
        useApiHooks<CompanyResponseType<ReviewsAnalysisCompanyType>>();

    const fetch = useCallback(
        (options: ReviewsAnalysisCompaniesQueryType & PaginationDataType, mainFilterKey: string): void => {
            setIsInProgress(true);
            setProcessError(null);

            fetchReviewCompanies(options, mainFilterKey)
                .then(setResult)
                .finally(() => setIsInProgress(false))
                .catch(setProcessError);
        },
        [setResult, setIsInProgress, setProcessError]
    );

    return {isInProgress, processError, result, reset, fetch};
}

export function useReviewCompanyGroups(): ReviewAnalysisCompanyGroupsHookType {
    const {isInProgress, setIsInProgress, processError, setProcessError, result, setResult, reset} =
        useApiHooks<CompanyResponseType<ReviewsAnalysisCompanyGroupType>>();

    const fetch = useCallback(
        (options: ReviewsAnalysisCompaniesQueryType & PaginationDataType, mainFilterKey: string): void => {
            setIsInProgress(true);
            setProcessError(null);

            fetchReviewCompanyGroups(options, mainFilterKey)
                .then(setResult)
                .finally(() => setIsInProgress(false))
                .catch(setProcessError);
        },
        [setResult, setIsInProgress, setProcessError]
    );

    return {isInProgress, processError, result, reset, fetch};
}
